export const RENT_HOUSE = {
  isHidden: true,
  nickname: 'PRODUCTS.RENT_HOUSE.nickname',
  icon:'rent-house'
};
